/* eslint-disable-next-line import/named */
import styled, { css, } from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectTypography } from "../../utils/injectTypography.mjs.mjs";
import { injectOSXFontSmoothing } from "../../utils/injectOSXFontSmoothing.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
import { Text } from "../Text/index.mjs.mjs";
export const AUTO_WIDTH_BREAKPOINT = '440px';
export const BTN_SIZE_S = '48px';
export const BTN_SIZE_M = '56px';
export const StyledButtonLabel = styled.span.withConfig({ displayName: "auir-611444a-StyledButtonLabel", componentId: "auir-611444a-nngqoa" }) `
  margin-inline-start: ${(props) => props.icon && `var(${props.theme.responsive.spacing.s})`};

  text-align: start;

  transform: ${(props) => props.size === 'small' && 'translateY(0.05em)'};
  ${(props) => injectOSXFontSmoothing(props.size !== 'small')}
`;
// All buttons are styled as disabled, then other styles are applied if an `href` attribute is present or the button is discovered not to be disabled.
export const injectCommonButtonStyles = (props) => css `
  position: relative;
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: var(
    ${props.isLoading
    ? props.theme.colors.interaction.primary.default
    : props.theme.colors.interaction.primary.disabled}
  );
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  background-color: transparent;
  border: none;
  border-radius: 0;
  outline-offset: 2px;
  cursor: ${props.isLoading ? 'progress' : 'not-allowed'};
  transition-timing-function: var(${props.theme.easing});
  transition-duration: 250ms;
  transition-property: color, background-color, box-shadow, border-radius;
  appearance: none;
  user-select: none;

  &[href],
  &[type]:not(:disabled) {
    color: var(${props.theme.colors.interaction.primary.default});

    cursor: pointer;
    user-select: initial;

    @media (hover: hover) {
      &:hover {
        color: var(${props.theme.colors.interaction.primary.hover});
      }
    }
  }

  ${injectSpacing('margin')}
  ${injectTypography(props, props.size === 'small' ? 'copy2' : 'copy1')}
  ${injectOSXFontSmoothing(true)}
`;
export const injectBlockButtonStyles = () => css `
  justify-content: center;
  width: 100%;
  min-width: 9em;
  padding-block-start: 1em;
  padding-inline-end: 2em;
  padding-block-end: 1em;
  padding-inline-start: 2em;
  min-height: ${(props) => (props.size === 'small' ? BTN_SIZE_S : BTN_SIZE_M)};
  box-shadow: inset 0 0 0 1px
    var(
      ${(props) => props.isLoading
    ? props.theme.colors.interaction.primary.default
    : props.theme.colors.interaction.primary.disabled}
    );

  &[href],
  &[type]:not(:disabled) {
    box-shadow: inset 0 0 0 1px
      var(${(props) => props.theme.colors.interaction.primary.default});

    @media (hover: hover) {
      &:hover {
        box-shadow: inset 0 0 0 1px
          var(${(props) => props.theme.colors.interaction.primary.hover});
      }
    }
  }

  ${(props) => props.variant.includes('primary') &&
    css `
      color: var(${props.theme.colors.ui.inverted});
      background-color: var(
        ${props.isLoading
        ? props.theme.colors.interaction.primary.default
        : props.theme.colors.interaction.primary.disabled}
      );

      &[href],
      &[type]:not(:disabled) {
        color: var(${props.theme.colors.ui.inverted});
        background-color: var(
          ${props.theme.colors.interaction.primary.default}
        );

        @media (hover: hover) {
          &:hover {
            color: var(${props.theme.colors.ui.inverted});
            background-color: var(
              ${props.theme.colors.interaction.primary.hover}
            );
          }
        }
      }
    `}

  @media (min-width: ${AUTO_WIDTH_BREAKPOINT}) {
    width: ${(props) => (props.stretch ? '100%' : 'auto')};
  }
`;
export const injectTextButtonStyles = () => css `
  padding-inline-end: 5px;

  &[href],
  &[type]:not(:disabled) {
    ${StyledArrow} {
      stroke: var(${(props) => props.theme.colors.interaction.primary.default});
    }
    @media (hover: hover) {
      &:hover {
        ${StyledArrow} {
          transform: translateX(5px);
          [dir='rtl'] & {
            transform: rotate(180deg) translateX(5px);
          }
          stroke: var(
            ${(props) => props.theme.colors.interaction.primary.hover}
          );
        }
      }
    }
  }
`;
export const injectIconPrimaryStyles = (props) => css `
  background-color: var(${props.theme.colors.interaction.primary.default});

  ${(props) => props.elevated &&
    css `
      filter: var(${props.theme.shadow.background.level[2]});
    `}
  @media (hover: hover) {
    &:hover {
      background-color: var(
        ${props.isLoading
    ? props.theme.colors.interaction.primary.default
    : props.theme.colors.interaction.primary.hover}
      );
    }
  }
  &:disabled {
    background-color: var(
      ${(props) => props.isLoading ? '' : props.theme.colors.interaction.primary.disabled}
    );
  }
`;
export const injectIconSecondaryStyles = (props) => css `
  color: var(${props.theme.colors.interaction.primary.default});
  ${(props) => props.elevated
    ? css `
          filter: var(${props.theme.shadow.background.level[2]});
          background-color: var(
            ${(props) => props.theme.colors.background.level[2]}
          );
        `
    : 'background-color: transparent;'}
  @media (hover: hover) {
    &:hover {
      color: var(
        ${props.isLoading
    ? props.theme.colors.interaction.primary.default
    : props.theme.colors.interaction.primary.hover}
      );
      box-shadow: inset 0 0 0 1px
        var(${(props) => props.theme.colors.interaction.primary.hover});
    }
  }
  &:disabled {
    ${(props) => props.isLoading
    ? ''
    : css `
            color: var(
              ${(props) => props.theme.colors.interaction.primary.disabled}
            );
            box-shadow: inset 0 0 0 1px
              var(${(props) => props.theme.colors.interaction.primary.disabled});
          `}
  }
`;
export const injectIconTertiaryStyles = (props) => css `
  &[href],
  &[type]:not(:disabled) {
    box-shadow: none;
    @media (hover: hover) {
      &:hover {
        box-shadow: none;
      }
    }
  }

  color: var(${props.theme.colors.interaction.primary.default});
  ${(props) => props.elevated
    ? css `
          filter: var(${props.theme.shadow.background.level[2]});
          background-color: var(
            ${(props) => props.theme.colors.background.level[2]}
          );
        `
    : 'background-color: transparent;'}
  @media (hover: hover) {
    &:hover {
      color: var(
        ${props.isLoading
    ? props.theme.colors.interaction.primary.default
    : props.theme.colors.interaction.primary.hover}
      );
    }
  }
  &:disabled {
    color: var(
      ${(props) => props.isLoading ? '' : props.theme.colors.interaction.primary.disabled}
    );
  }
`;
export const StyledTransitionContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledTransitionContainer", componentId: "auir-611444a-13fz1o8" }) `
  pointer-events: none;

  display: flex;
  align-items: center;
  justify-content: center;

  ${(props) => props.overlay
    ? css `
          position: absolute;
          inset: 0;
        `
    : ''}

  opacity: ${(props) => (props.visible ? '1' : '0')};
  transition: 300ms var(${(props) => props.theme.easing});
  transition-property: opacity;
  transition-delay: ${(props) => (props.visible ? '300ms' : '0')};
`;
export const StyledArrow = styled.svg.withConfig({ displayName: "auir-611444a-StyledArrow", componentId: "auir-611444a-1jr4kdp" }) `
  flex-shrink: 0;
  width: 0.5em;
  height: 0.8125em;
  margin-inline-start: 0.25em;

  transition: 250ms var(${(props) => props.theme.easing});
  transition-property: transform, stroke;

  [dir='rtl'] & {
    transform: rotate(180deg);
  }
`;
export const StyledIconContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledIconContainer", componentId: "auir-611444a-1w3235o" }) `
  flex-grow: 0;
  flex-shrink: 0;
  width: 24px;
  height: 24px;

  overflow: hidden;
`;
export const StyledButton = styled.button.withConfig({ displayName: "auir-611444a-StyledButton", componentId: "auir-611444a-2jei6v" }) `
  ${injectCommonButtonStyles}

  ${(props) => {
    switch (props.variant) {
        case 'primary':
        case 'secondary':
            return injectBlockButtonStyles();
        case 'text':
            return injectTextButtonStyles();
        default:
            return injectBlockButtonStyles();
    }
}}
`;
export const StyledIconButton = styled.button.withConfig({ displayName: "auir-611444a-StyledIconButton", componentId: "auir-611444a-zmw0pw" }) `
  ${injectCommonButtonStyles}
  ${injectBlockButtonStyles}
  min-width: ${(props) => (props.size === 'small' ? BTN_SIZE_S : BTN_SIZE_M)};
  max-width: ${(props) => (props.size === 'small' ? BTN_SIZE_S : BTN_SIZE_M)};
  box-sizing: border-box;
  padding-inline-end: 1em;
  padding-inline-start: 1em;
  border-radius: ${(props) => (props.isLoading ? '50%' : '0%')};
  overflow: hidden;

  ${(props) => props.label &&
    css `
      margin-bottom: 0;
    `}
  ${(props) => {
    switch (props.variant) {
        case 'icon-primary':
            return injectIconPrimaryStyles(props);
        case 'icon-secondary':
            return injectIconSecondaryStyles(props);
        case 'icon-tertiary':
            return injectIconTertiaryStyles(props);
        default:
            return injectIconPrimaryStyles(props);
    }
}}
  ${(props) => props.size === 'medium' &&
    css `
      div[role='progressbar'] svg {
        width: ${BTN_SIZE_M};
        height: ${BTN_SIZE_M};
      }
    `}
`;
export const StyledIconButtonWrapper = styled.div.withConfig({ displayName: "auir-611444a-StyledIconButtonWrapper", componentId: "auir-611444a-t24pyt" }) `
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
`;
export const StyledIconButtonLabel = styled(Text).withConfig({ displayName: "auir-611444a-StyledIconButtonLabel", componentId: "auir-611444a-1hhg86r" }) `
  margin-top: var(${(props) => props.theme.responsive.spacing.s});
  ${injectSpacing('margin')}
`;
//# sourceMappingURL=Button.styles.mjs.mjs.map